export default "__VITE_ASSET__B5fy2qwb__"